import { detail } from './detail';

export const homes = {
    routeTitle: 'Lokality',
    route: 'Lokality',
    listOfHomes: 'Zoznam lokalít',
    addHome: 'Pridať lokalitu',
    editHome: 'Upraviť lokalitu',
    addHomeResident: 'Pozvať nového užívateľa',
    processingInvitationLink: 'Spracovávame pozvánku, prosím počkajte...',
    invitationSuccesfullySent: 'Pozvánka bola úspešne odoslaná.',
    wrongUserInvitation1:
        'Chyba pri pokuse o prijatie pozvánky. Možno pozvánka už bola prijatá alebo ste pripojení k nesprávnemu používateľovi. Momentálne ste pripojený ako ',
    wrongUserInvitation2:
        '. Overte prosím e-mail pozvánky, potom sa v prípade potreby prihláste so správnym používateľom a skúste to znova.',
    acceptInvitationSuccess: 'Pozvánka bola prijatá',
    name: 'Názov',
    postalCode: 'Poštové smerovacie číslo',
    owner: 'Vlastník',
    sureToDeleteContent: 'Názov lokality na vymazanie: ',
    sureToUndeleteContent: 'Názov lokality na obnovenie: ',
    euroPerKwhBuy: 'Cena za nákup kWh',
    euroPerKwhSell: 'Cena za kWh predaja',
    kgco2PerKwh: 'kg CO2 za kWh',
    kwLimit: 'Maximálny limit kW siete používa sa na nabíjanie OCPP_Gateway',
    kwhEuro: 'Eur/kWh',
    switchesInstalled: 'Spínače nainštalované',
    unlimited: 'Bez obmedzení',
    switchInstallationNotAllowed:
        'Ďalšia inštalácia spínača nie je povolená. Prosíme, zvýšte svoj plán v cloud-e.',
    switchList: 'Zoznam spínačov',
    addSwitch: 'Pridať spínač',
    priority: 'Priorita',
    readyAt: 'Pripravený o',
    offFrom: 'Vypnutý od',
    offTo: 'do',
    assignedDevice: 'Zariadenie',
    assignedPhase: 'Fáza',
    usageThresholdAlert: 'Spotreba energie',
    alwaysOnAlert: 'Vždy zapnutý',
    dataMissingAlert: 'Chýbajúce dáta',
    next: 'Ďalej >',
    back: '< Dozadu',
    finish: 'Koniec',
    switchModel: 'Model',
    switchName: 'Názov',
    switchIotAddress: 'IoT zariadenie/SmartPi adresa',
    switchSSID: 'Názpv lokálnej Wi-Fi (SSID)',
    switchWifiPassword: 'Heslo lokálnej Wi-Fi',
    switchInstallationStep2:
        "Vypnite mobilné dáta, pripojte váš mobil k Wi-Fi s názvom začínajúcim na 'shelly-' a stlačte tlačidlo 'Ďalej'",
    switchInstallationStep3:
        "Pripojte váš mobil k internetu a stlačte tlačidlo 'Ďalej'",
    switchInstallationStep4:
        'Spínač je úspešne nakonfigurovaný. [sk]  Please attach a device to it and make it usable. You will see the configuration form in next step.',
    editRelay: 'Upraviť relé',
    editSwitch: 'Upraviť spínač',
    relayMode: 'Pracovný mód',
    relayDevice: 'Zariadenie',
    relayPhase: 'Fáza',
    relayPriority: 'Priorita',
    relayReadyAt: 'Pripravené o',
    relayOffFrom: 'Vypnuté od',
    relayOffTo: 'Relé vypnuté do',
    deleteSwitch: 'Vymazať spínač',
    confirmDeleteSwitch: 'Chcete naozaj vymazať tento spínač?',
    reconfig: 'Zmeniť konfiguráciu',
    modbusId: 'Modbus Id',
    ski: 'SKI',
    detail
};